import React from 'react'
import { Container, Row } from 'react-bootstrap'

export default function lostPassword() {
    return (
        <section>
            <div className="lost-password-sec">
                <Container>
                    <Row>
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="lost-password-box">
                                <p>Lost your blue key? Please enter your registered email address. You will receive a link to create a new blue key via email.</p>
                                <label>Username or email</label>
                                <form>
                                    <input type="text" name placeholder />
                                    <button type="submit">Get a new blue key</button>
                                </form>
                            </div>
                        </div>
                    </Row>
                </Container>
            </div>
        </section>
    )
}
